import { createClient } from '@/shared/api';
import { logError } from '@/shared/lib/apiHelpers';
import type { MeQuery, MeQueryVariables } from '@/shared/api/generated/graphql';
import ME_QUERY from '../queries/me';

/**
 * Loads the signed-in user's profile. Runs the me query and, on any failure, reports the error through the shared logger and yields an empty object instead of throwing.
 *
 * @returns A promise resolving to the current user, or an empty object when the query failed.
 */
const fetchMe = async () => {
  try {
    const client = await createClient();
    const result = await client.query<MeQuery, MeQueryVariables>({ query: ME_QUERY });
    return result.data.me;
  } catch (error) {
    logError('Failed to fetch me: ', error);
    return {};
  }
};

export default fetchMe;
